'use client';

import { useState } from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';
import Image from 'next/image';

interface HeaderProps {
  className?: string;
}

const Header = ({ className = '' }: HeaderProps) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // const navigationItems = [
  //   { label: 'Accueil', href: '/homepage', icon: 'HomeIcon' },
  //   { label: 'Contacter le support', href: '/contact-support', icon: 'ChatBubbleLeftRightIcon' },
  //   // { label: 'Aperçu de l’événement', href: '/event-overview', icon: 'CalendarIcon' },
  //   // { label: 'Portail exposants', href: '/exhibitor-portal', icon: 'BuildingStorefrontIcon' },
  //   // { label: 'Inscription visiteurs', href: '/visitor-registration', icon: 'UserPlusIcon' },
  //   // { label: 'Matchmaking B2B', href: '/business-matchmaking', icon: 'UsersIcon' },
  // ];
  // const moreItems = [
  //   { label: 'Contacter le support', href: '/contact-support', icon: 'ChatBubbleLeftRightIcon' }, //contact-support
  // ];
  const navigationItems = [
    { label: 'Home', href: '/homepage', icon: 'HomeIcon' },
    { label: 'About', href: '/homepage#about', icon: 'InformationCircleIcon' },
    { label: 'Why Exhibit', href: '/homepage#why-exhibit', icon: 'StarIcon' },
    { label: 'Sectors', href: '/homepage#sectors', icon: 'Squares2X2Icon' },
    { label: 'Program', href: '/homepage#program', icon: 'CalendarDaysIcon' },
    { label: 'Participation', href: '/participation', icon: 'UserGroupIcon' },
    // { label: 'Contact', href: '/homepage#contact', icon: 'EnvelopeIcon' },
  ];
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header data-component-id="src/components/common/Header.tsx:40:4" data-component-path="src/components/common/Header.tsx" data-component-line="40" data-component-file="Header.tsx" data-component-name="header" data-component-content="%7B%22elementName%22%3A%22header%22%7D"
      className={`fixed top-0 left-0 right-0 z-50 bg-card border-b border-border shadow-warm ${className}`}
    >
      <div data-component-id="src/components/common/Header.tsx:43:6" data-component-path="src/components/common/Header.tsx" data-component-line="43" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20px-4%20sm%3Apx-6%20lg%3Apx-8%22%7D" className="w-full px-4 sm:px-6 lg:px-8">
        <div data-component-id="src/components/common/Header.tsx:44:8" data-component-path="src/components/common/Header.tsx" data-component-line="44" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20justify-between%20h-16%22%7D" className="flex items-center justify-between h-16">
          {/* Logo Section */}
          <Link data-component-id="src/components/common/Header.tsx:46:10" data-component-path="src/components/common/Header.tsx" data-component-line="46" data-component-file="Header.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22%2Fhomepage%22%2C%22className%22%3A%22flex%20items-center%20space-x-3%20hover%3Aopacity-90%20transition-smooth%22%7D"
            href="/homepage"
            className="flex items-center space-x-3 hover:opacity-90 transition-smooth"
          >
            {/* <div className="relative w-10 h-10 flex items-center justify-center bg-primary rounded-lg">
              <svg
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="w-8 h-8"
              >
                <path
                  d="M20 5L8 12V28L20 35L32 28V12L20 5Z"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M20 5V35M8 12L32 28M32 12L8 28"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
              </svg>
            </div>
            <div className="hidden sm:block">
              <div className="text-lg font-bold text-foreground leading-tight">
                Madagascar Africa
              </div>
              <div className="text-xs text-muted-foreground font-medium">Business Expo</div>
            </div> */}
            <div data-component-id="src/components/common/Header.tsx:78:12" data-component-path="src/components/common/Header.tsx" data-component-line="78" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22my-5%22%7D" className="my-5">
              <Image data-component-id="src/components/common/Header.tsx:79:14" data-component-path="src/components/common/Header.tsx" data-component-line="79" data-component-file="Header.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22src%22%3A%22https%3A%2F%2Fres.cloudinary.com%2Fdx3xhdaym%2Fimage%2Fupload%2Fv1768381305%2Fmada_bus_expo-03_1_joehhr.png%22%2C%22alt%22%3A%22logo%22%7D"
                src={
                  'https://res.cloudinary.com/dx3xhdaym/image/upload/v1768381305/mada_bus_expo-03_1_joehhr.png'
                }
                alt="logo"
                width={130}
                height={70}
              />
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav data-component-id="src/components/common/Header.tsx:91:10" data-component-path="src/components/common/Header.tsx" data-component-line="91" data-component-file="Header.tsx" data-component-name="nav" data-component-content="%7B%22elementName%22%3A%22nav%22%2C%22className%22%3A%22hidden%20lg%3Aflex%20items-center%20space-x-1%22%7D" className="hidden lg:flex items-center space-x-1">
            {navigationItems.map((item) => (
              <Link data-component-id="src/components/common/Header.tsx:93:14" data-component-path="src/components/common/Header.tsx" data-component-line="93" data-component-file="Header.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22className%22%3A%22flex%20items-center%20space-x-2%20px-4%20py-2%20text-sm%20font-medium%20text-foreground%20hover%3Atext-primary%20hover%3Abg-muted%20rounded-lg%20transition-smooth%22%7D"
                key={item.href}
                href={item.href}
                className="flex items-center space-x-2 px-4 py-2 text-sm font-medium text-foreground hover:text-primary hover:bg-muted rounded-lg transition-smooth"
              >
                <Icon data-component-id="src/components/common/Header.tsx:98:16" data-component-path="src/components/common/Header.tsx" data-component-line="98" data-component-file="Header.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%7D" name={item.icon as any} size={18} variant="outline" />
                <span data-component-id="src/components/common/Header.tsx:99:16" data-component-path="src/components/common/Header.tsx" data-component-line="99" data-component-file="Header.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D">{item.label}</span>
              </Link>
            ))}

            {/* More Dropdown */}
            {/* <div className="relative group">
              <button className="flex items-center space-x-2 px-4 py-2 text-sm font-medium text-foreground hover:text-primary hover:bg-muted rounded-lg transition-smooth">
                <Icon name="EllipsisHorizontalIcon" size={18} variant="outline" />
                <span>More</span>
              </button>

              <div className="absolute right-0 mt-2 w-56 bg-card border border-border rounded-lg shadow-warm-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-smooth">
                {moreItems.map((item) => (
                  <Link
                    key={item.href}
                    href={item.href}
                    className="flex items-center space-x-3 px-4 py-3 text-sm font-medium text-foreground hover:text-primary hover:bg-muted first:rounded-t-lg last:rounded-b-lg transition-smooth"
                  >
                    <Icon name={item.icon as any} size={18} variant="outline" />
                    <span>{item.label}</span>
                  </Link>
                ))}
              </div>
            </div> */}
          </nav>

          {/* CTA Buttons */}
          <div data-component-id="src/components/common/Header.tsx:126:10" data-component-path="src/components/common/Header.tsx" data-component-line="126" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22hidden%20lg%3Aflex%20items-center%20space-x-3%22%7D" className="hidden lg:flex items-center space-x-3">
            <Link data-component-id="src/components/common/Header.tsx:127:12" data-component-path="src/components/common/Header.tsx" data-component-line="127" data-component-file="Header.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22%2Fhomepage%23contact%22%2C%22className%22%3A%22px-4%20py-2%20text-sm%20flex%20gap-2%20items-center%20font-semibold%20text-primary-foreground%20bg-primary%20rounded-lg%20hover%3Abg-primary%2F90%20shadow-warm%20hover%3Ashadow-warm-lg%20transition-smooth%22%2C%22textContent%22%3A%22Contact%22%7D"
              href="/homepage#contact"
              className="px-4 py-2 text-sm flex gap-2 items-center font-semibold text-primary-foreground bg-primary rounded-lg hover:bg-primary/90 shadow-warm hover:shadow-warm-lg transition-smooth"
            >
              <Icon data-component-id="src/components/common/Header.tsx:131:14" data-component-path="src/components/common/Header.tsx" data-component-line="131" data-component-file="Header.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22UserPlusIcon%22%7D" name={'UserPlusIcon'} size={18} variant="outline" />
              Contact
            </Link>
            {/* <Link
              href="/exhibitor-portal"
              className="px-4 py-2 text-sm font-semibold text-primary-foreground bg-primary rounded-lg hover:bg-primary/90 shadow-warm hover:shadow-warm-lg transition-smooth"
            >
              Become an Exhibitor
            </Link> */}
          </div>

          {/* Mobile Menu Button */}
          <button data-component-id="src/components/common/Header.tsx:143:10" data-component-path="src/components/common/Header.tsx" data-component-line="143" data-component-file="Header.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22lg%3Ahidden%20p-2%20text-foreground%20hover%3Atext-primary%20hover%3Abg-muted%20rounded-lg%20transition-smooth%22%7D"
            onClick={toggleMobileMenu}
            className="lg:hidden p-2 text-foreground hover:text-primary hover:bg-muted rounded-lg transition-smooth"
            aria-label="Toggle mobile menu"
          >
            <Icon data-component-id="src/components/common/Header.tsx:148:12" data-component-path="src/components/common/Header.tsx" data-component-line="148" data-component-file="Header.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%7D" name={isMobileMenuOpen ? 'XMarkIcon' : 'Bars3Icon'} size={24} variant="outline" />
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div data-component-id="src/components/common/Header.tsx:155:8" data-component-path="src/components/common/Header.tsx" data-component-line="155" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22lg%3Ahidden%20border-t%20border-border%20bg-card%22%7D" className="lg:hidden border-t border-border bg-card">
          <nav data-component-id="src/components/common/Header.tsx:156:10" data-component-path="src/components/common/Header.tsx" data-component-line="156" data-component-file="Header.tsx" data-component-name="nav" data-component-content="%7B%22elementName%22%3A%22nav%22%2C%22className%22%3A%22px-4%20py-4%20space-y-1%22%7D" className="px-4 py-4 space-y-1">
            {[...navigationItems].map(
              (
                item // ...moreItems
              ) => (
                <Link data-component-id="src/components/common/Header.tsx:161:16" data-component-path="src/components/common/Header.tsx" data-component-line="161" data-component-file="Header.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22className%22%3A%22flex%20items-center%20space-x-3%20px-4%20py-3%20text-sm%20font-medium%20text-foreground%20hover%3Atext-primary%20hover%3Abg-muted%20rounded-lg%20transition-smooth%22%7D"
                  key={item.href}
                  href={item.href}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="flex items-center space-x-3 px-4 py-3 text-sm font-medium text-foreground hover:text-primary hover:bg-muted rounded-lg transition-smooth"
                >
                  <Icon data-component-id="src/components/common/Header.tsx:167:18" data-component-path="src/components/common/Header.tsx" data-component-line="167" data-component-file="Header.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%7D" name={item.icon as any} size={20} variant="outline" />
                  <span data-component-id="src/components/common/Header.tsx:168:18" data-component-path="src/components/common/Header.tsx" data-component-line="168" data-component-file="Header.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D">{item.label}</span>
                </Link>
              )
            )}

            <div data-component-id="src/components/common/Header.tsx:173:12" data-component-path="src/components/common/Header.tsx" data-component-line="173" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22pt-4%20space-y-2%20border-t%20border-border%20mt-4%22%7D" className="pt-4 space-y-2 border-t border-border mt-4">
              {/* <Link
                href="/visitor-registration"
                onClick={() => setIsMobileMenuOpen(false)}
                className="block w-full px-4 py-3 text-sm font-semibold text-center text-foreground border border-border rounded-lg hover:bg-muted transition-smooth"
              >
                Register as Visitor
              </Link> */}

              <Link data-component-id="src/components/common/Header.tsx:182:14" data-component-path="src/components/common/Header.tsx" data-component-line="182" data-component-file="Header.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22%2Fhomepage%23contact%22%2C%22className%22%3A%22px-4%20py-2%20text-sm%20flex%20gap-2%20items-center%20font-semibold%20text-primary-foreground%20bg-primary%20rounded-lg%20hover%3Abg-primary%2F90%20shadow-warm%20hover%3Ashadow-warm-lg%20transition-smooth%22%2C%22textContent%22%3A%22Contact%22%7D"
                href="/homepage#contact"
                className="px-4 py-2 text-sm flex gap-2 items-center font-semibold text-primary-foreground bg-primary rounded-lg hover:bg-primary/90 shadow-warm hover:shadow-warm-lg transition-smooth"
              >
                <Icon data-component-id="src/components/common/Header.tsx:186:16" data-component-path="src/components/common/Header.tsx" data-component-line="186" data-component-file="Header.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22UserPlusIcon%22%7D" name={'UserPlusIcon'} size={18} variant="outline" />
                Contact
              </Link>

              {/* <Link
                href="/visitor-registration"
                onClick={() => setIsMobileMenuOpen(false)}
                className="  w-full px-4 py-2 text-sm flex gap-2 items-center font-semibold text-primary-foreground bg-primary rounded-lg hover:bg-primary/90 shadow-warm hover:shadow-warm-lg transition-smooth"
              >
                <Icon name={'UserPlusIcon'} size={18} variant="outline" /> Inscription
              </Link> */}

              {/* <Link
                href="/exhibitor-portal"
                onClick={() => setIsMobileMenuOpen(false)}
                className="block w-full px-4 py-3 text-sm font-semibold text-center text-primary-foreground bg-primary rounded-lg hover:bg-primary/90 shadow-warm transition-smooth"
              >
                Become an Exhibitor
              </Link> */}
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
